export default "__VITE_ASSET__Cz$AXVIf__"